import { Injectable, Type } from "@angular/core";

import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  FnTransferableArg,
  UiArguments,
} from "shared/provider-webworker";

import { OrderDataLookupService } from "./OrderDataLookupService";
import { ReplicaBlotterLookupService } from "../../impl/ReplicaBlotterLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import { IOrderDataPromiseLookupService } from "../IOrderDataPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
import { IOrderMigrationEvent } from "shared/cubiq-services/model/core/IOrderMigrationEvent";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderDataReplicaLookupService
  extends ReplicaBlotterLookupService<string, CubiqTS.OrderDataImpl>
  implements IOrderDataPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.OrderDataImpl, "OrderDataImpl", CubiqTS.OrderLifeCycleEventImpl, true);
  }

  getAllOrderDatas(): Promise<Array<CubiqTS.OrderDataImpl>> {
    let request = new UiArguments("getAllOrderDatas");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  startUpdates(): void {}

  subscribeForMarketBar(pairNames: Array<string>): Promise<Array<any>> {
    let request = new UiArguments("subscribeForMarketBar");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  getOrderData(id: string): Promise<CubiqTS.OrderDataImpl> {
    let request = new UiArguments("getOrderData");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getOrderReference(id: string): Promise<string> {
    let request = new UiArguments("getOrderReference");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getModifyPreInitDataForOrderId(id: string): Promise<any> {
    let request = new UiArguments("getModifyPreInitDataForOrderId");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getOrderDataForIds(ids: Array<string>): Promise<Array<CubiqTS.OrderDataImpl>> {
    let request = new UiArguments("getOrderDataForIds");
    let arg1 = new FnArg(ids, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  hasOrdersForRateKey(subscriptionKey: string): Promise<boolean> {
    let request = new UiArguments("hasOrdersForRateKey");
    let arg1 = new FnArg(subscriptionKey, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  subscribeForRates(): Promise<void> {
    let request = new UiArguments("subscribeForRates");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  addOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("addOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  removeOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("removeOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  hasOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("hasOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  // Stub, does nothing
  getTransferUpdateSubject(): Subject<any> {
    return null;
  }

  protected getModelUpdateEventType(): Type<CubiqTS.ConcreteEncodable> {
    return CubiqTS.OrderLifeCycleEventImpl;
  }

  public getModelOrderMigrationSubject(): Subject<IOrderMigrationEvent> {
    return null;
  }
}
